import * as AppConstants from 'app/AppConstants';
import {searchEntities} from '../search/searchService';
import {ENTITY_TYPES} from 'app/SearchConstants';

export const search = query => dispatch => {
  searchEntities([[ENTITY_TYPES.USER.TYPE]], query, 20).then(response => {
    dispatch({
      type: AppConstants.PEOPLE__SEARCH_RESULTS,
      payload: {
        results: response.searchObjects.map(result => ({
          ...result,
          id: result.databaseId,
        })),
      },
    });
  });

  dispatch({
    type: AppConstants.PEOPLE__SEARCH,
    payload: {
      query,
    },
  });
};

export const reset = () => ({
  type: AppConstants.PEOPLE__SEARCH_RESET,
});
